import { styled, ButtonBase } from "@mui/material";
import { type ReactNode } from "react";

import { Badge } from "@/components/Badge/Badge";
import type { ButtonProps } from "@/components/Button";

const StyledButton = styled(ButtonBase)(() => ({
  color: "var(--color-text-interactive)",
  fontWeight: "500",
  fontSize: "14px",
  letterSpacing: "0",
  lineHeight: "20px",
  borderRadius: "var(--radius-2xl)",
  padding: "0",
  width: "80px",
  backgroundColor: "var(--color-white)",
  transition: "transform 0.2s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
  },
  "&>*": {
    width: "100%",
  },
}));

type SearchNavigationButtonProps = {
  badgeContent?: ReactNode;
} & ButtonProps;

export const SearchNavigationButton = ({
  badgeContent,
  children,
  ...buttonProps
}: SearchNavigationButtonProps) => {
  const contents = (
    <span className="flex w-full flex-col items-center gap-2 p-2">
      {children}
    </span>
  );

  return (
    <StyledButton {...buttonProps}>
      {badgeContent ? (
        <Badge badgeContent={<span aria-hidden>{badgeContent}</span>}>
          {contents}
        </Badge>
      ) : (
        contents
      )}
    </StyledButton>
  );
};
